import axios from "axios";

const API = axios.create({
  baseURL: "https://fdp.deviotechworkspace.com/api",
  // baseURL: "http://localhost:8000/api"
});

export const updatePermission=(token, user_id)=>
  API.get(`/update-permission/${user_id}`, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

export const fetchCourse = (token, user_id) =>
  API.get(`/get-course/${user_id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const updateCourse = (token, user_id)=>
  API.get(`/update-course/${user_id}`, {
    headers: {  
      Authorization: `Bearer ${token}`,
    },
  });

export const getQuestion = (token, topic_id,u_id, lastStatus)=>
  API.get(`/get-question/${topic_id}/${u_id}/${lastStatus}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  export const getFinalquestions = (token, topic_id,u_id)=>
    API.get(`/get-final-question/${topic_id}/${u_id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    export const getExam = (token, user_id) =>
      API.get(`/get-exam/${user_id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

export const fetchSecurityQuestions = (token) =>
  API.get(`/get-security-questions`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const getTestResults = (token, user_id) =>
  API.get(`/get-results/${user_id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const downloadPdf = (token, user_id) =>
  API.get(`/download-pdf/${user_id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    responseType: 'blob',
  });

export const storeSecurityQuestions = (token,formData,userId) =>
  API.post(`/store-security-questions/${userId}`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });

export const courseDetail = (token) =>
  API.get(`/course-detail`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const fetchTopics = (token, sectionId) =>
  API.get(`/get-topics/${sectionId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const fetchPages = (token, topicId, user_id) =>
  API.get(`/get-pages/${topicId}/${user_id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const fetchRemainingTime = (token, topicId, user_id) =>
  API.get(`/get-topic-time/${topicId}/${user_id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const updateTopic = (token, pageId, user_id, remainingTime, timeElapsed = null) => {
  // Backward compatible:
  // - If timeElapsed is provided (non-null), include it in the URL
  // - Otherwise call the legacy endpoint without the extra segment
  const hasTimeElapsed = timeElapsed !== null && timeElapsed !== undefined;
  const url = hasTimeElapsed
    ? `/update-topic-time/${pageId}/${user_id}/${remainingTime}/${timeElapsed}`
    : `/update-topic-time/${pageId}/${user_id}/${remainingTime}`;

  return API.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// Standalone total-time-elapsed API (course-wide)
export const updateTotalTimeElapsed = (token, data) =>
  API.post(`/update-total-time-elapsed`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

export const updateTopicStatus = (token, id, user_id, user_ans ,q_id) =>
  API.get(`/update-topic-status/${id}/${user_id}/${user_ans}/${q_id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const submitCourse = (token, topic_id, user_id, user_ans, question_id) =>
  API.get(`/submit-course/${topic_id}/${user_id}/${user_ans}/${question_id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

 

  export const submitFinalquiz = (token,formdata) =>
    API.post(`/submit-final-quiz`, formdata, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    export const submitExam= (token,formdata) =>
      API.post(`/submit-exam`, formdata, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
  

export const checkPage = (token, pageId, user_id) =>
  API.get(`/check-page/${pageId}/${user_id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const checkTopic = (token, topicId, user_id) =>
  API.get(`/check-topic/${topicId}/${user_id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const getTopics = (token, user_id) =>
  API.get(`/get-topics-progress/${user_id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const updateStatus = (token, topicId, user_id) =>
  API.get(`/update-status/${topicId}/${user_id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
export const updateProfile = (token, formData) =>
  API.post(`/update-profile`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });

export const getUserData = (token) =>
  API.get(`/user-data`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const updateUserProfileData = (token, data) =>
  API.post(`/update-user-profile-data`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });


export const getPaymentIntent = (id) => API.get(`/payment-intent`);
export const getPaymentRetakeIntent = (id) => API.get(`/payment-retake-intent`);

export const userValidate = (formData) => API.post("/user-validate", formData);
export const register = (formData) => API.post("/user-register", formData);
export const login = (formData) => API.post("/user-login", formData);
export const forgotPassword = (formData) => API.post("/forgot-password", formData);
export const resetPassword = (token, formData) => API.post("/reset-password", formData, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

// Resets password via signed URL params coming from email
export const customResetPassword = (data) => API.post("/password/custom-reset", data, {
  headers: {
    "Content-Type": "application/json",
  },
});

export const getGoogleMapsApiKey = () => API.get("/get-google-maps-api-key");

// Security Challenge APIs
export const getChallengeQuestion = (token, user_id, timeElapsed) =>
  API.get(`/get-challenge-question/${user_id}/${timeElapsed}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const validateChallengeAnswer = (token, data) =>
  API.post(`/validate-challenge-answer`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

export const consumeRetakeCourse = (token, user_id) =>
  API.post(`/consume-retake-course/${user_id}`, {}, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
export const markTestFailed = (token, data) =>
  API.post(`/mark-test-failed`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
